import { FILE_DIALOG_HOT_KEYS, FILES_TABLE_HOT_KEYS } from './pageHotKeys';

export const HOT_KEY_ACTIONS = [...FILE_DIALOG_HOT_KEYS, ...FILES_TABLE_HOT_KEYS];
